import {
    ACTION_GET_CAPTCHA,
    ACTION_GET_CAPTCHA_ERROR,
    ACTION_GET_CAPTCHA_SUCCESS,
    ACTION_TERMINATE_CONTRACT,
    ACTION_TERMINATE_CONTRACT_ERROR,
    ACTION_TERMINATE_CONTRACT_SUCCESS,
} from './constant';
import { ExtractActions } from '@vfde-sails/core';
import {
    CaptchaMediaType,
    ICaptcha,
    ICustomerInformation,
    IError,
} from './interface';

/**
 * Send a request with the customer information and get back the validation data
 * Export terminateConract
 */
export const terminateContract = (customerInformation: ICustomerInformation, captcha: ICaptcha) => ({
    type: ACTION_TERMINATE_CONTRACT,
    customerInformation,
    captcha,
});

/**
 * terminateContract reponded with the validated customerInformation successfully
 * Export terminateConract
 */
export const terminateContractSuccess = (customerInformation: ICustomerInformation) => ({
    type: ACTION_TERMINATE_CONTRACT_SUCCESS,
    customerInformation,
});

/**
 * terminateContract reponded with an error
 */
export const terminateContractError = (error: IError) => ({
    type: ACTION_TERMINATE_CONTRACT_ERROR,
    error,
});

/**
 * Send a get request to get a captcha
 */
export const getCaptcha = (captchaMediaType: CaptchaMediaType) => ({
    type: ACTION_GET_CAPTCHA,
    captchaMediaType,
});

/**
 * Responded with a captcha image
 */
export const getCaptchaSuccess = (captchaUrl: string, captchaMediaType: CaptchaMediaType, captchaHash: string) => ({
    type: ACTION_GET_CAPTCHA_SUCCESS,
    captchaUrl,
    captchaMediaType,
    captchaHash,
});

/**
 * Responded with an error
 */
const getCaptchaError = (error: IError) => ({
    type: ACTION_GET_CAPTCHA_ERROR,
    error,
});

/**
 * Action Creators Object
 */
export const actionCreators = {
    terminateContract,
    terminateContractSuccess,
    terminateContractError,
    getCaptcha,
    getCaptchaSuccess,
    getCaptchaError,
};

/**
 * Action Dispatchers Object
 */
export const actionDispatchers = {
    terminateContract,
    terminateContractSuccess,
    terminateContractError,
    getCaptcha,
    getCaptchaSuccess,
    getCaptchaError,
};

/**
 * Action Creators
 */
export type ActionCreators = typeof actionCreators;

/**
 * Action Dispatchers
 */
export type ActionDispatchers = typeof actionDispatchers;

/**
 * Union Action Type
 */
export type Action = ExtractActions<ActionCreators>;
